import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

class ProductPreparation extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.closest('.shopify-section, dialog')?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.closest('.shopify-section, dialog')?.removeEventListener(
      StandardEvents.productSelect,
      this.#handleProductSelect
    );
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        if (detail.newProduct) {
          this.dataset.productId = detail.newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const blockId = this.dataset.blockId;
        const selector = blockId
          ? `product-preparation[data-block-id="${CSS.escape(blockId)}"]`
          : 'product-preparation';
        const updatedMessage = detail.html.querySelector(selector);

        if (updatedMessage) morph(this, updatedMessage, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-preparation] Variant update failed:', error);
      });
  };
}

if (!customElements.get('product-preparation')) {
  customElements.define('product-preparation', ProductPreparation);
}
